import { isLastMessage, isSameSender, isSameSenderMargin, isSameUser, } from "../config/ChatLogics";
import { ChatState } from "../Context/ChatProvider";
import { extractTime, extractTimeOderDate } from "../utils/functions";
import { useEffect, useRef, useState } from "react";
import ConfirmModal from "./Modals/ConfirmModal/ConfirmModal";
import MessageItem from "./MessageItem";
import ImageItem from "./ImageItem";


const ScrollableChat = ({ messages, deleteMessageHandler, onSaveScrollTop, onClearScrollTop, scrollTopBeforeDeleteSingleChat, secretCode, newMessage }) => {
    const { user, selectedChat, showToast } = ChatState();
    const [isOpen, setIsOpen] = useState(false);
    const [userId, setUserId] = useState("");
    const [messageContent, setMessageContent] = useState("");
    const [messageId, setMessageId] = useState("");
    const chatContainerRef = useRef(null);
    
    const handleSaveScrollTop = () => {
        if (chatContainerRef.current && onSaveScrollTop) {
            onSaveScrollTop(chatContainerRef.current.scrollTop);
        }
    };
    const onClickSpanFunction = (e, userId, messageId) => {
        setIsOpen(true);
        e.preventDefault();
        setMessageId(messageId);
        const content = messages.find(u => u._id === messageId).content;
        setUserId(userId);
        setMessageContent(content);
        handleSaveScrollTop();
    }
    const onClose = async (e) => {
        setIsOpen(false);
        if (messageContent &&  e.target.textContent === "Cancel") {
            try {
                await navigator.clipboard.writeText(messageContent);
                showToast('info', 'Message copied to clipboard.');
            } catch (err) {
                console.error('Failed to copy text: ', err);
                showToast('warning', 'Message is not copied.');
            } finally {
                setMessageContent("");
            }
        }
    }

    const scrollTopRef = useRef(0);  //UseRef for storing scroll position

    const saveScrollPosition = () => {
        if (chatContainerRef.current) {
            scrollTopRef.current = chatContainerRef.current.scrollTop;   // Save scroll position
        }
    };
    useEffect(() => {
        const savedScrollTop = scrollTopBeforeDeleteSingleChat;
        if (chatContainerRef.current) {
            const container = chatContainerRef.current;
            if (savedScrollTop !== null && savedScrollTop !== undefined) {
                // Set the scroll position to the saved value
                container.scrollTop = savedScrollTop;
            } else {
                // Wenn no saved scroll position, scroll to bottom
                container.scrollTop = container.scrollHeight;
            }
        }
    }, [messages, selectedChat, scrollTopBeforeDeleteSingleChat]);
    const read = true;
    return (
        <div className='scrollable' ref={chatContainerRef}>
            <ConfirmModal onConfirm={() => deleteMessageHandler(userId, messageId)} onClose={onClose} isOpen={isOpen} content={"You can only delete your own messages. Delete?"} />
            {messages &&
                messages.map((m, i) => {
                    return (<div style={{ display: "flex" }} key={m._id}>
                        {(isSameSender(messages, m, i, user._id) ||
                            isLastMessage(messages, i, user._id)) && selectedChat.isGroupChat && (
                                <span className='chat_message_avatar' label={m.sender.name} placement="bottom-start" >
                                    <img alt='avatar' className='chat_message_avatar_image' src={m.sender.pic} />
                                </span>
                            )}
                        <span className='chatMessage'
                            style={{
                                backgroundColor: `${m.sender._id === user._id ? "#BEE3F8" : "#DBFFDB"
                                    }`,
                                marginLeft: selectedChat.isGroupChat
                                    ? isSameSenderMargin(messages, m, i, user._id)
                                    : !selectedChat.isGroupChat && m.sender._id === user._id
                                        ? isSameSenderMargin(messages, m, i, user._id)
                                        : 0,
                                marginTop: selectedChat.isGroupChat && isSameUser(messages, m, i, user._id) ? 2 : 6,
                                minWidth: m.pic ? '50%' : '50%',
                            }}
                            onContextMenu={(e) => onClickSpanFunction(e, user._id, m._id)}
                        >

                            {m.sender._id !== user._id && selectedChat.isGroupChat ? <span className='chatMessageName'>{m.sender.name}</span> : null}
                            <MessageItem key={m._id} message={m} />
                            
                            {m.pic && m.pic.startsWith('http') &&   <ImageItem  message={m} secretCode={secretCode} newMessage={newMessage} />}
                            <span className={`chatMessageTime ${m.sender._id !== user._id || read ? "" : "unread"}`}>
                                {extractTimeOderDate(m.updatedAt)}
                                <span className='chatMessageDate'> {extractTime(m.updatedAt)}</span>
                            </span>
                        </span>
                    </div>)
                })}
        </div>
    );
};

export default ScrollableChat;
